function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#39C696",
  width: "14",
  height: "14",
  rx: "1.556"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.004 6.247a1.829 1.829 0 100-3.658 1.829 1.829 0 000 3.658zm0-2.917a1.089 1.089 0 110 2.177 1.089 1.089 0 010-2.177zM3.549 7.322a1.407 1.407 0 100-2.813 1.407 1.407 0 000 2.813zm0-2.073a.666.666 0 110 1.333.666.666 0 010-1.333zM10.459 7.322a1.407 1.407 0 100-2.813 1.407 1.407 0 000 2.813zm0-2.073a.666.666 0 110 1.333.666.666 0 010-1.333zM10.508 8.065a1.95 1.95 0 00-.928.242 3.049 3.049 0 00-2.527-1.42 3.049 3.049 0 00-2.527 1.42 1.95 1.95 0 00-.927-.242A2.207 2.207 0 001.5 10.363a.37.37 0 00.74 0A1.47 1.47 0 013.6 8.805c.204.002.405.055.583.155-.174.44-.263.909-.263 1.382a.37.37 0 00.74 0c0-1.498 1.074-2.715 2.394-2.715s2.394 1.217 2.394 2.715a.37.37 0 00.74 0c.001-.473-.088-.942-.263-1.382.179-.1.38-.153.584-.155a1.47 1.47 0 011.357 1.558.37.37 0 10.74 0 2.207 2.207 0 00-2.097-2.298z",
  fill: "#FFF"
}))));